module.exports = __webpack_public_path__ + "static/K3.d5f54cef.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/K3.jpg
// module id = 462
// module chunks = 37721738025407